import {AfterViewInit, Component, ElementRef, HostListener, inject, Input, OnInit, ViewChild} from '@angular/core';
import {GridComponent} from '@syncfusion/ej2-angular-grids';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {formatCurrency} from '@angular/common';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';

/* PDF Erzeugung */
import jsPDF from 'jspdf';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {DokumentDataService} from 'src/app/services/dokument-data.service';
import {MailFormComponent} from './mail-form/mail-form.component';
import {Router} from '@angular/router';
import {DokumentModels} from 'src/app/models/dokument-models';
import {GlobalModels} from 'src/app/models/global-models';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {HtmlEditor, Image, Link, QuickToolbar, RichTextEditor, Toolbar} from '@syncfusion/ej2-angular-richtexteditor';
import {PDFReportService} from 'src/app/services/pdfreport.service';
import {ZahlenFormatPipe} from 'src/app/pipes/zahlen-format.pipe';
import {ReportModels} from 'src/app/models/report-models';
import {SwissAppConfigModels} from 'src/app/models/swissappconfig-models';
import {UserAuthenticationService} from 'src/app/services/user-authentication.service';
import {BehaviorSubject, combineLatest, map, of, startWith, tap} from 'rxjs';
import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';
import DokumentTyp = DokumentModels.DokumentTyp;
import DokumentSource = DokumentModels.DokumentSource;
import DokumentInfo = DokumentModels.DokumentInfo;
import SwissAppConfig = SwissAppConfigModels.SwissAppConfig;
import {catchError, filter} from "rxjs/operators";

RichTextEditor.Inject(Toolbar, Link, HtmlEditor, Image, QuickToolbar);

/* Ende PDF Erzeugung */

@Component({
    selector: 'app-rapport', templateUrl: './rapport.component.html', styleUrls: ['./rapport.component.scss'],
})
export class RapportComponent implements OnInit, AfterViewInit {
    svcSwissSettings = inject(SwissSettingsService);

    @ViewChild('gridRapport') public grid?: GridComponent;
    @ViewChild('sigCanvas') signatureCanvas?: ElementRef<HTMLCanvasElement>;
    @ViewChild('content', {static: false}) el!: ElementRef;
    @ViewChild('richTxtManuDesc') rteManuDesc?: RichTextEditor;
    public contextSignatureCanvas?: CanvasRenderingContext2D | undefined | null;
    @Input() formGroupRapport: UntypedFormGroup;
    previousPoint: { x: number; y: number } | null = null;
    public currTermin?: ServiceAppModels.SA_Objekt;
    public rapportZeilen?: ServiceAppModels.SA_RapportZeile[];
    public mwstSatz: string;
    // Felder für Rapport-Anzeige auf Tablet
    public kundenAdresse = '';
    public mitarbeiter = '';
    public isSigned$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public cbIsChecked$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public canCreateMailRapport$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public sa_Config?: ServiceAppModels.SA_Config;
    public rapportGenerationInProgress$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public canCreateRapport: BehaviorSubject<boolean> = new BehaviorSubject(false);
    protected readonly isManuDescRichText = toSignal(
        this.svcSwissSettings.getServiceAppConfig().pipe(
            map((config: SwissAppConfig) => config.richTextFormat_ManuDesc === 1),
            catchError((err, caught) => caught.pipe(startWith(undefined)))
        ), {initialValue: undefined}
    );
    private paint = false;
    private clickX: number[] = [];
    private clickY: number[] = [];
    private clickDrag: boolean[] = [];
    private readonly currAnwender?: BenutzerModels.Anwender;
    private currKundenAdresse?: ServiceAppModels.SA_Adress;
    private totalPreisExkl = 0.0;
    private totalMwSt = 0.0;
    private totalPreisInkl = 0.0;
    private rapportFile?: ServiceAppModels.SA_RapportFile;
    private waehrung = 'CHF';
    /* PDF-Erzeugung */
    private sa_PDFRapport: ServiceAppModels.SA_PDFRapport = {
        invoice: undefined, positions: {}, type: 'Type_SA_Rapport'
    };
    private checkListExists = false;

    constructor(private svcSA: ServiceAppService,
                private _datumFormatPipe: DatumFormatPipe,
                private _zahlenFormatPipe: ZahlenFormatPipe,
                private userAuthService: UserAuthenticationService,
                private svcPDFReport: PDFReportService,
                private dokuData: DokumentDataService,
                private router: Router,
                public dialog: MatDialog,
                private svcMessageBox: MessageBoxService) {
        this.currAnwender = this.userAuthService.getCurrentAuthenticatedUser();

        this.mitarbeiter = this.currAnwender!.firstName + ' ' + this.currAnwender!.lastName;
        this.mwstSatz = String((Math.round(this.currAnwender!.sA_PercentageVAT! * 100) / 100).toFixed(2)).replace(',', '.');
        this.formGroupRapport = new UntypedFormGroup({
            fldJobDone: new UntypedFormControl(),
        });

        combineLatest({
            isSigned: this.isSigned$, isChecked: this.cbIsChecked$, canCreateMailRapport: this.canCreateMailRapport$, rapportGenInProgress: this.rapportGenerationInProgress$
        }).pipe(takeUntilDestroyed(), tap((args) => {
            this.canCreateRapport.next(args.isSigned && args.isChecked && !args.canCreateMailRapport && !args.rapportGenInProgress);
        })).subscribe();

        this.svcSA.getTimesChanged$().pipe(
            takeUntilDestroyed(),
            tap(() => this.refreshGrid())
        ).subscribe();
    }


    /* START CANVAS */
    ngAfterViewInit(): void {
        // Canvas
        if (this.signatureCanvas) {
            this.contextSignatureCanvas = this.signatureCanvas!.nativeElement.getContext('2d');
            this.contextSignatureCanvas!.fillStyle = 'black';
            this.contextSignatureCanvas!.clearRect(0, 0, this.signatureCanvas!.nativeElement.width, this.signatureCanvas!.nativeElement.height);

            /* Canvas Events */
            this.contextSignatureCanvas!.canvas.addEventListener('mousedown', this.pressEventHandler);
            this.contextSignatureCanvas!.canvas.addEventListener('mousemove', this.dragEventHandler);
            this.contextSignatureCanvas!.canvas.addEventListener('mouseup', this.releaseEventHandler);
            this.contextSignatureCanvas!.canvas.addEventListener('mouseout', this.cancelEventHandler);

            this.contextSignatureCanvas!.canvas.addEventListener('touchstart', this.pressEventHandler);
            this.contextSignatureCanvas!.canvas.addEventListener('touchmove', this.dragEventHandler);
            this.contextSignatureCanvas!.canvas.addEventListener('touchend', this.releaseEventHandler);
            this.contextSignatureCanvas!.canvas.addEventListener('touchcancel', this.cancelEventHandler);

            this.contextSignatureCanvas!.lineCap = 'round';
            this.contextSignatureCanvas!.lineJoin = 'round';
            this.contextSignatureCanvas!.strokeStyle = 'black';
            this.contextSignatureCanvas!.lineWidth = 2;
            this.redraw();
        }
    }

    @HostListener('window:resize', ['$event']) onResize(event: any) {
        if (this.rteManuDesc) {
            this.rteManuDesc.width = window.innerWidth - 470;
        }
    }

    clearSignature(): void {
        this.contextSignatureCanvas!.clearRect(0, 0, this.signatureCanvas!.nativeElement.width, this.signatureCanvas!.nativeElement.height);
        this.clickX = [];
        this.clickY = [];
        this.clickDrag = [];
        this.isSigned$.next(false);
    }

    setJobDone(enabled: boolean) {
        this.cbIsChecked$.next(enabled);
    }

    ngOnInit(): void {
        this.currTermin = this.svcSA.getTermin();
        this.checkListExists = this.svcSA.existsChecklistenByServiceID(this.currTermin!.serviceID);

        // Die Beschreibung mit dem HTML-Leerschlag wird auf "" gesetzt
        if (this.currTermin.manufacturingDescription === '&nbsp;') {
            this.currTermin.manufacturingDescription = '';
        }

        // die Notiz mit dem HTML-Leerschlag wird auf "" gesetzt
        if (this.currTermin.memo === '&nbsp;') {
            this.currTermin.memo = '';
        }

        if (this.currTermin) {
            this.currKundenAdresse = this.svcSA.getAuftragsAdresse(this.currTermin.objectID, GlobalModels.AdressTypes.Kunde);
            if (this.currKundenAdresse?.adressID) {
                if (this.currKundenAdresse.firstName) {
                    this.kundenAdresse = this.currKundenAdresse.firstName + ' ';
                }
                this.kundenAdresse += this.currKundenAdresse.lastName;
                if (this.currKundenAdresse.street1) {
                    this.kundenAdresse += '<br>' + this.currKundenAdresse.street1;
                }
                if (this.currKundenAdresse.zip) {
                    this.kundenAdresse += '<br>' + this.currKundenAdresse.zip + ' ' + this.currKundenAdresse.city;
                }
            }

            const dokumente = this.svcSA.getRapporteByServiceID(this.currTermin!.serviceID);
            this.canCreateMailRapport$.next(false);
            if (dokumente && dokumente.length === 1) {
                this.rapportFile = dokumente[0];
                this.canCreateMailRapport$.next(true);
            }

            this.sa_Config = this.svcSA.getSA_Config();
            if (this.sa_Config?.waehrungInRapportAnzeigen) {
                this.waehrung = 'CHF';
            } else {
                this.waehrung = '';
            }
        }
        this.loadRapportEntries();
    }

    refreshGrid() {
        this.totalPreisExkl = 0.0;
        this.totalMwSt = 0.0;
        this.totalPreisInkl = 0.0;
        this.loadRapportEntries();
    }

    async loadRapportEntries() {
        this.rapportZeilen = [];
        this.addAuftragsZeitenToRapport();
        this.addAuftragsProdukteToRapport();
        if (this.totalPreisExkl > 0.0 && this.currAnwender && this.currAnwender.sA_PercentageVAT && this.currAnwender.sA_PercentageVAT > 0.0) {
            console.log('Berechne MwSt....', this.totalPreisExkl, this.currAnwender.sA_PercentageVAT);
            this.totalMwSt = (this.currAnwender!.sA_PercentageVAT! * this.totalPreisExkl) / 100.0;
            // Hier wird die MwSt auf 0.05 Rappen gerundet
            this.totalMwSt = parseFloat((Math.round(this.totalMwSt * 20) / 20).toFixed(2));
            this.totalPreisInkl = this.totalPreisExkl + this.totalMwSt;
        }
    }

    getDisplayExpensesInRapport() {
        // Überprüft ob Spesen im Rapport angezeigt werden sollen
        let displayExpensesInRapport;
        if (this.currAnwender?.sA_ShowExpenseInRapport === 1) {
            if (this.svcSwissSettings.getWebConfig().debugMode) {
                console.log('Spesen im Rapport anzeigen Anwender');
            }
            displayExpensesInRapport = true;
        } else {
            if (this.svcSwissSettings.getWebConfig().debugMode) {
                console.log('Spesen im Rapport nicht anzeigen');
            }
            this.sa_Config = this.svcSA.getSA_Config();
            if (this.sa_Config?.spesenInRapportAnzeigen) {
                if (this.svcSwissSettings.getWebConfig().debugMode) {
                    console.log('Spesen im Rapport anzeigen Mandant');
                }
                displayExpensesInRapport = true;
            } else {
                if (this.svcSwissSettings.getWebConfig().debugMode) {
                    console.log('Spesen im Rapport nicht anzeigen Mandant');
                }
                displayExpensesInRapport = false;
            }
        }
        return displayExpensesInRapport;
    }

    addAuftragsZeitenToRapport() {
        // Die Zeiten aus der DB in anschaubare Daten umwandeln
        if (this.svcSA.getDBAuftragsZeiten(true)) {
            this.getDisplayExpensesInRapport();
            for (const auftragszeit of this.svcSA.getDBAuftragsZeiten(true)) {
                const datum = this._datumFormatPipe.transformOnlyDate(auftragszeit.startDate);
                const einheit = this.svcSA.getKurzzeichenStunden();

                let spesenDescription = '';
                if (auftragszeit.expenseID) {
                    spesenDescription = this.svcSA
                        .getDBSpesen()
                        .filter((sp) => sp.expenseID == auftragszeit.expenseID)[0].description;
                }
                // Für jeden Mitarbeiter wird einen Eintrag gemacht
                for (const mitarbeiter of auftragszeit.employeeIDS) {
                    // Arbeitszeit runden
                    const roundingTime = this.svcSA.getRoundingTimes();
                    let arbeitszeitGerundet = auftragszeit.duration;
                    arbeitszeitGerundet *= 60;

                    arbeitszeitGerundet = Math.ceil(arbeitszeitGerundet / roundingTime) * roundingTime;
                    arbeitszeitGerundet /= 60;

                    const arbeiter = this.svcSA
                        .getDBMitarbeiter()
                        .filter((m) => m.employeeID == mitarbeiter)[0];
                    const arbeiterName = arbeiter?.firstName + ' ' + arbeiter?.lastName;
                    const stundenAnsatz = this.svcSA.getDBMitarbeiterAnsatz(datum, arbeiter.employeeID);
                    const regieAnsatz = this.svcSA.getDBKostenstellenRegieAnsatz(datum, auftragszeit.costCenterID);
                    // Hier wird der Preis auf 5 Rappen gerundet
                    let auftragsAufwand: number = arbeitszeitGerundet * (stundenAnsatz + regieAnsatz);
                    auftragsAufwand = parseFloat((Math.ceil(auftragsAufwand * 20) / 20).toFixed(2));

                    const preisTotal = formatCurrency(auftragsAufwand, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');

                    const preis = formatCurrency(stundenAnsatz + regieAnsatz, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');

                    let spesenId = '';
                    if (auftragszeit.expenseID) {
                        spesenId = auftragszeit.expenseID.toString();
                    }

                    let spesenMenge = 0;
                    if (auftragszeit.expenseAmount) {
                        spesenMenge = auftragszeit.expenseAmount;
                    }

                    let spesenEinheit = '';
                    if (auftragszeit.expenseUnit) {
                        spesenEinheit = auftragszeit.expenseUnit;
                    }

                    let spesenBetrag = 0;
                    if (auftragszeit.expensePrice && auftragszeit.expenseToCharge) {
                        spesenBetrag = auftragszeit.expensePrice;
                    }

                    const spesenBetragFormatted = formatCurrency(spesenBetrag, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');

                    const spesenTotal = formatCurrency(spesenBetrag * spesenMenge, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');

                    if (!auftragszeit.goodWill) {
                        this.totalPreisExkl += Math.round(arbeitszeitGerundet * (stundenAnsatz + regieAnsatz) * 100) / 100; // Auf 0.05 Runden
                        if (auftragszeit.expenseToCharge) {
                            this.totalPreisExkl += spesenBetrag * spesenMenge;
                        }
                    }

                    // Normale Arbeitszeit
                    const zeile: ServiceAppModels.SA_RapportZeile = {
                        servicePosID: auftragszeit.servicePosID,
                        datum,
                        mitarbeiter: arbeiterName,
                        artikel: '',
                        bezeichnung: auftragszeit.activityDescription,
                        menge: Math.round(arbeitszeitGerundet * 100) / 100,
                        einheit,
                        preis,
                        preisTotal,
                        kulanz: auftragszeit.goodWill!,
                        spesen: false,
                    };

                    this.rapportZeilen?.push(zeile);

                    if (auftragszeit.expensePrice != 0 && auftragszeit.expensePrice != null) {
                        // Spesenaufwand
                        const zeile: ServiceAppModels.SA_RapportZeile = {
                            servicePosID: spesenId,
                            datum,
                            mitarbeiter: arbeiterName,
                            artikel: '',
                            bezeichnung: spesenDescription,
                            menge: spesenMenge,
                            einheit: spesenEinheit,
                            preis: spesenBetragFormatted,
                            preisTotal: spesenTotal,
                            kulanz: auftragszeit.goodWill!,
                            spesen: auftragszeit.expenseToCharge!,
                        };
                        this.rapportZeilen?.push(zeile);
                    }
                }
            }
        }
    }

    addAuftragsProdukteToRapport() {
        // Die Positionen aus der DB in anschaubare Daten umwandeln
        const auftragsProdukte = this.svcSA.getDBAuftragsProdukte();
        console.log('auftragsProdukte', auftragsProdukte);
        let totalSumme = 0.0;
        if (auftragsProdukte) {
            // Die Zeiten aus der DB in anschaubare Daten umwandeln
            for (const auftragsprodukt of auftragsProdukte) {
                const posDatum = this._datumFormatPipe.transformOnlyDate(auftragsprodukt.datum);

                let myLaengeBreiteDicke = '';
                if (auftragsprodukt.laenge) {
                    myLaengeBreiteDicke = String(auftragsprodukt.laenge);
                }

                if (auftragsprodukt.breite) {
                    myLaengeBreiteDicke += '/' + String(auftragsprodukt.breite) + '/';
                }

                if (auftragsprodukt.dicke) {
                    myLaengeBreiteDicke += String(auftragsprodukt.dicke);
                }

                let myPreisProEinheit = '';
                if (auftragsprodukt.preisProEinheit) {
                    myPreisProEinheit = formatCurrency(auftragsprodukt.preisProEinheit, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');
                }

                let myPreisTotal = '';
                if (auftragsprodukt.preisTotal) {
                    const preisTotalGerundet: number = this._zahlenFormatPipe.round5(auftragsprodukt.preisTotal);
                    totalSumme += preisTotalGerundet;
                    if (!auftragsprodukt.kulanz) {
                        this.totalPreisExkl += preisTotalGerundet;
                    }

                    myPreisTotal = formatCurrency(preisTotalGerundet, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');
                }

                let menge = auftragsprodukt.anzahl;
                if (auftragsprodukt.mengeTotal) {
                    menge = auftragsprodukt.mengeTotal;
                }

                const mitarbeiter = auftragsprodukt.mitarbeiter.firstName + ' ' + auftragsprodukt.mitarbeiter.lastName;
                const positionszeile: ServiceAppModels.SA_RapportZeile = {
                    servicePosID: auftragsprodukt.servicePosID,
                    datum: posDatum,
                    mitarbeiter,
                    artikel: auftragsprodukt.artikelnummer,
                    bezeichnung: auftragsprodukt.bezeichnung,
                    menge,
                    einheit: auftragsprodukt.einheit,
                    preis: myPreisProEinheit,
                    preisTotal: myPreisTotal,
                    kulanz: auftragsprodukt.kulanz,
                    spesen: auftragsprodukt.spesen,
                };
                this.rapportZeilen?.push(positionszeile);
            }
            if (this.grid) {
                this.grid.refresh();
            }
        }
    }

    // Funktionen für die Summierung von Preisen / MwSt
    public customAggregateTotalExkl = (sdata: String) => formatCurrency(this.totalPreisExkl, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');

    public customAggregateMwSt = (sdata: String) => formatCurrency(this.totalMwSt, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');

    public customAggregateTotalInkl = (sdata: String) => formatCurrency(this.totalPreisInkl, 'de-CH', this.waehrung, '1.2-2').replace(',', '.');

    // Das Feld Kulanz erhält je nach Wert ein anderes Image
    imgSrc(value?: boolean): string {
        let htmlStr = 'cancel.png';
        if (value) {
            htmlStr = 'ok.png';
        }
        return htmlStr;
    }

    /* Mail mit PDF-Rapport erstellen */
    async createMailWithRapport() {
        const dialogRef = this.dialog.open(MailFormComponent, {
            disableClose: true, width: '700px',
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result !== '') {
                    const mailTemplate: ServiceAppModels.MailTemplate = result;

                    if (this.svcSwissSettings.getWebConfig().debugMode) {
                        console.log('Mail versandt.', result);
                    }

                    this.svcSA
                        .sendRapportMail(this.rapportFile!.documentID, mailTemplate)
                        .subscribe({
                            next: (res) => {
                                console.log(res);
                                this.svcMessageBox.showSuccess('Der Rapport konnte via Mail versandt werden!!', 'Erfolgreich');
                            }, error: (err) => (this.svcMessageBox.showError('⚠️ ❗❗ Der Rapport konnte nicht via Mail versandt werden!! ❗❗ ⚠️', '!! FEHLER !!')),
                        });
                }
            },
        });
    }

    resetData() {
        this.totalPreisExkl = 0.0;
        this.totalMwSt = 0.0;
        this.totalPreisInkl = 0.0;
        this.ngOnInit();
    }

    /* PDF-Erzeugung START */
    async createRapport(): Promise<void> {
        if (this.currAnwender?.sA_EditChecklist === 1 && !this.checkListExists) {
            this.svcMessageBox.showError('Es wird eine Checkliste zur Erstellung des Rapports benötigt!!', '!! FEHLER !!');
            return;
        }

        if (this.rapportGenerationInProgress$.getValue()) {
            return;
        }
        this.rapportGenerationInProgress$.next(true);

        if (!this.sa_PDFRapport.invoice) {
            this.sa_PDFRapport.invoice = await this.initRapport();
        }

        this.sa_PDFRapport.invoice!.mandantAdr = this.userAuthService.getCurrentMandant();
        this.sa_PDFRapport.invoice!.logo = await this.svcSA.loadRapportLogo();

        if (this.sa_PDFRapport.invoice) {
            try {
                this.svcPDFReport.AddFontArial(this.sa_PDFRapport.invoice.doc);
                this.svcPDFReport.AddFontHelveticaBold(this.sa_PDFRapport.invoice.doc);

                if (this.sa_PDFRapport.invoice.template.SA_InvoiceItems) {
                    this.svcPDFReport.generateRapport(this.sa_PDFRapport, this.currTermin!, this.totalPreisExkl, this.totalMwSt, this.totalPreisInkl, this.signatureCanvas!, this.isSigned$.getValue()).then((res) => {

                        const serviceRepResultat = res as ReportModels.ServiceReportResult;
                        this.svcSA.saveRapport(serviceRepResultat.serviceID, serviceRepResultat.objectID, serviceRepResultat.name, serviceRepResultat.binary).then((res) => {
                            if (res) {
                                this.svcMessageBox.showSuccess('Der Rapport wurde erfolgreich erstellt.', 'Erfolgreich');
                            }
                            this.resetData();
                            this.svcSA.setServiceComplete(this.currTermin!);
                            this.rapportGenerationInProgress$.next(false);
                        }, (err) => {
                            this.svcMessageBox.showError('Der Rapport konnte nicht gespeichert werden!!', '!! FEHLER !!');
                            this.rapportGenerationInProgress$.next(false);
                        });
                    });
                }
            } catch (ex: any) {
                this.rapportGenerationInProgress$.next(false);
                this.svcMessageBox.showError(ex.message, 'Fehler im Erstellen des Rapports: ');
            }
        } else {
            this.rapportGenerationInProgress$.next(false);
        }
    }

    async showRapport(): Promise<void> {
        if (!this.rapportFile) {
            return;
        }
        if (!this.currTermin) {
            return;
        }
        // Der Rapport soll im PDF-Viewer angezeigt werden
        const pdfList = this.svcSA.getTerminDokumenteList(this.currTermin.serviceID, this.currTermin.objectID).filter(terminActivity => terminActivity.imageFile === 'pdf.png').flatMap<DokumentInfo>(pdfActivity => {
            return {
                objectID: this.currTermin!.objectID,
                documentID: pdfActivity.id,
                description: pdfActivity.description,
                fileName: pdfActivity.documentName,
                dokumentTyp: DokumentTyp.Notizblatt,
                dokumentQuelle: DokumentSource.FromWebService,
                lastModified: new Date()
            };
        });
        this.dokuData.setPDFDokument(this.currTermin.objectID, this.rapportFile.documentID, this.rapportFile.fileName, this.rapportFile.description, DokumentModels.DokumentTyp.Rapport, DokumentModels.DokumentSource.SA_DBRapporte, this.rapportFile.lastModified || new Date(), pdfList);
        await this.router.navigate(['pdfviewer', this.rapportFile?.documentID]);
    }

    async initRapport() {
        const reports = await this.svcSwissSettings.getServiceAppReports();
        let serviceReport: SwissAppConfigModels.SwissAppReport | undefined;
        serviceReport = reports.find(x => x.iD_SwissAppReportType === 1);
        if (serviceReport) {
            if (!this.rapportZeilen) {
                this.rapportZeilen = [];
            }

            return {
                template: JSON.parse(serviceReport.pdfFormularConfigJSONData),
                doc: new jsPDF('p', 'pt', 'a4'),
                pdf: null,
                completed: false,
                mandantAdr: null,
                columns: [],
                rows: this.rapportZeilen,
                pointer: 0,
                output: null,
                name: 'Lieferschein.pdf',
                address: null,
                MiscTablePos: null,
                data: [],
                reset: false,
                relativepageadded: false,
                logo: '',
                footerLogoPath: '',
                logoFooter: '',
                printPositionsTable: serviceReport.printPositionsTable
            };
        } else {
            this.svcMessageBox.showError('Es konnte kein Report für den Service-Rapport ermittelt werden. ', '!! Fehler !!');
            throw new Error('No report could be found');
        }
    }

    load() {
        (this.grid!.localeObj as any).localeStrings.EmptyRecord = 'Keine Zeiten/Materialien eingetragen';
    }

    private redraw() {
        const clickX = this.clickX;
        const clickDrag = this.clickDrag;
        const clickY = this.clickY;
        for (let i = 0; i < clickX.length; ++i) {
            this.contextSignatureCanvas!.beginPath();
            if (clickDrag[i] && i) {
                this.contextSignatureCanvas!.moveTo(clickX[i - 1], clickY[i - 1]);
            } else {
                this.contextSignatureCanvas!.moveTo(clickX[i] - 1, clickY[i]);
            }
            this.contextSignatureCanvas!.lineTo(clickX[i], clickY[i]);
            this.contextSignatureCanvas!.stroke();
        }
        this.contextSignatureCanvas!.closePath();
    }

    private addClick(x: number, y: number, dragging: boolean) {
        this.clickX.push(x);
        this.clickY.push(y);
        this.clickDrag.push(dragging);
    }

    private pressEventHandler = (e: MouseEvent | TouchEvent) => {
        const rect = this.signatureCanvas!.nativeElement.getBoundingClientRect();
        const mouseX = (e as TouchEvent).changedTouches ? (e as TouchEvent).changedTouches[0].pageX - rect.left : (e as MouseEvent).offsetX;

        const mouseY = (e as TouchEvent).changedTouches ? (e as TouchEvent).changedTouches[0].pageY - rect.top : (e as MouseEvent).offsetY;

        if (!this.isSigned$.getValue()) {
            this.isSigned$.next(true);
        }
        this.paint = true;
        this.addClick(mouseX, mouseY, false);
        this.redraw();
    }

    private dragEventHandler = (e: MouseEvent | TouchEvent) => {
        const rect = this.signatureCanvas!.nativeElement.getBoundingClientRect();

        const mouseX = (e as TouchEvent).changedTouches ? (e as TouchEvent).changedTouches[0].pageX - rect.left : (e as MouseEvent).offsetX;
        const mouseY = (e as TouchEvent).changedTouches ? (e as TouchEvent).changedTouches[0].pageY - rect.top : (e as MouseEvent).offsetY;

        if (this.paint) {
            this.addClick(mouseX, mouseY, true);
            this.redraw();
        }
        e.preventDefault();
    }

    private releaseEventHandler = () => {
        this.paint = false;
        this.redraw();
    }

    private cancelEventHandler = () => {
        this.paint = false;
    }
}
